// ============================================================
// SKILL CATALOG - Data-driven registry of Deathwatch skills.
// Basic skills can be tested untrained at half the governing
// characteristic; advanced skills cannot be tested untrained.
// Dodge and Parry live here too (they predate the catalog -
// the defence chain keeps its own resolution path).
// ============================================================
import type { CharacteristicId, SkillId } from './types';

export type { SkillId };

export interface SkillDefinition {
  id: SkillId;
  name: string;
  governing: CharacteristicId;
  /** Advanced skills cannot be tested untrained (basic = half characteristic). */
  advanced: boolean;
}

/** Sorted alphabetically by display name. */
export const SKILL_CATALOG: SkillDefinition[] = [
  { id: 'acrobatics', name: 'Acrobatics', governing: 'agi', advanced: true },
  { id: 'awareness', name: 'Awareness', governing: 'per', advanced: false },
  { id: 'carouse', name: 'Carouse', governing: 'tgh', advanced: false },
  { id: 'charm', name: 'Charm', governing: 'fel', advanced: false },
  { id: 'chem_use', name: 'Chem-Use', governing: 'int', advanced: true },
  { id: 'climb', name: 'Climb', governing: 'str', advanced: false },
  { id: 'command', name: 'Command', governing: 'fel', advanced: false },
  { id: 'concealment', name: 'Concealment', governing: 'agi', advanced: false },
  { id: 'contortionist', name: 'Contortionist', governing: 'agi', advanced: false },
  { id: 'deceive', name: 'Deceive', governing: 'fel', advanced: false },
  { id: 'demolition', name: 'Demolition', governing: 'int', advanced: true },
  { id: 'dodge', name: 'Dodge', governing: 'agi', advanced: false },
  { id: 'evaluate', name: 'Evaluate', governing: 'int', advanced: false },
  { id: 'gamble', name: 'Gamble', governing: 'int', advanced: false },
  { id: 'inquiry', name: 'Inquiry', governing: 'fel', advanced: false },
  { id: 'interrogation', name: 'Interrogation', governing: 'wp', advanced: true },
  { id: 'intimidate', name: 'Intimidate', governing: 'str', advanced: false },
  { id: 'invocation', name: 'Invocation', governing: 'wp', advanced: true },
  { id: 'literacy', name: 'Literacy', governing: 'int', advanced: true },
  { id: 'logic', name: 'Logic', governing: 'int', advanced: false },
  { id: 'medicae', name: 'Medicae', governing: 'int', advanced: true },
  { id: 'parry', name: 'Parry', governing: 'ws', advanced: false },
  { id: 'psyniscience', name: 'Psyniscience', governing: 'per', advanced: true },
  { id: 'scrutiny', name: 'Scrutiny', governing: 'per', advanced: false },
  { id: 'search', name: 'Search', governing: 'per', advanced: false },
  { id: 'security', name: 'Security', governing: 'agi', advanced: true },
  { id: 'shadowing', name: 'Shadowing', governing: 'agi', advanced: true },
  { id: 'silent_move', name: 'Silent Move', governing: 'agi', advanced: false },
  { id: 'sleight_of_hand', name: 'Sleight of Hand', governing: 'agi', advanced: true },
  { id: 'survival', name: 'Survival', governing: 'int', advanced: true },
  { id: 'swim', name: 'Swim', governing: 'str', advanced: false },
  { id: 'tech_use', name: 'Tech-Use', governing: 'int', advanced: true },
  { id: 'tracking', name: 'Tracking', governing: 'int', advanced: true },
  { id: 'wrangling', name: 'Wrangling', governing: 'int', advanced: true },
];

export const SKILL_MAP: Record<SkillId, SkillDefinition> = Object.fromEntries(
  SKILL_CATALOG.map((s) => [s.id, s]),
) as Record<SkillId, SkillDefinition>;

export const SKILL_IDS: SkillId[] = SKILL_CATALOG.map((s) => s.id);

export function getSkillDef(id: string): SkillDefinition | undefined {
  return (SKILL_MAP as Record<string, SkillDefinition>)[id];
}
